import { Grid, LinearProgress } from "@material-ui/core";
import Axios from "axios";
import React, { Component } from "react";
import Pagination from "react-js-pagination";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import AppConfig from "../../../../../../config/AppConfig";
import { Notice} from "../../../../../../../_metronic/_partials/controls";
const columns = [
    {
      name: <><div style={{fontSize: 16}}>Nama Perguruan Tinggi</div></>,
      selector: row => row.nm_lemb,
      sortable: true,
    },
    {
      name: <><div style={{fontSize: 16}}>Jumlah Pengisian Pengaturan</div></>,
      selector: row => row.presentase,
      sortable: true,
    },
    {
      name: <><div style={{fontSize: 16}}>Aksi</div></>,
      grow: 0,
      width: '150px',
      textAlign: 'center',
      cell: row => 
      <a href={`/detail-pt/`+row.id_sp} onClick={() => handleSearch(row)} className="btn btn-primary">
          <span className="flaticon-eye"></span>
      </a>
    }
  ]
  const handleSearch = (row) => {
    localStorage.setItem("id_sp_temp",row.id_sp);
    localStorage.setItem("nama_id",row.nm_lemb);
    window.location.reload();
  }
class TableListPTMengisi extends Component {
    constructor(props) {
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        super(props)
        this.state = {
          ref_lingkup:[],
          lingkup_kordinasi: sessiondata.i_idunit,
          keyword:"",
          display: false,
          loading: false,
          datatable: [],
          globalState: [],
          limit:10,
          totalRows: 0,
          last_page: 1,
          jm_pages:0,
          activePage:1,
          kelengkapan_pengaturan:'0',
          total_pt: "Loading..",
          // ======================
          label : ['Loading ..', 'Loading..'],
          datasets : [{
            data: [1, 1],
            backgroundColor: ['#e0e0e0', '#8f9491']
          }],
        }
      }
      
      onInputChangeName = (e, type) => {
        console.log(e.target.value);
        this.setState({
            [type] : e.target.value
        })
      }
      async componentDidMount(){
        this.setState({display: false});
        let id_institusi = localStorage.getItem("id_sp_temp");
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let id_sp = sessiondata.i_idunit;
        if(id_institusi !== ""){
            id_sp = id_institusi;
        }if(id_institusi === null){
            id_sp = sessiondata.i_idunit;
        }
        let session = "";
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        if(userdata){
            session = 
            // "?token="+userdata.token+
            "?id_pengguna="+userdata.id_pengguna+
            "&id_unit="+ id_sp +
            "&id_role="+sessiondata.i_idrole;
        }
        var formData = new FormData();
        formData.append('data[id_unit]', this.state.lingkup_kordinasi);
        formData.append('data[mengisi]', "presentase");
        Axios.post(
            AppConfig.urlApiGetListPT+session+"&limit="+this.state.limit, formData
          ).then(res => {
            this.setState({
              globalState : res,
              data: res.data.result.data,
              totalRows: res.data.result.total_rows,
              ref_lingkup: res.data.result.ref_lingkup,
              loading: false,
              display: true,
            });
          }) 
          .catch(err => {
            alert("not found")
            console.log(err)
            this.setState({
              loading: false,
              display: false,
            });
          }) 
    }
    handlePageChange = (pageNumber) =>{
      const {limit} = this.state;
      // let jm_page = "";
      //     if(pageNumber > last_page){
      //         jm_page = jm_pages+limit;
      //     }else{
      //         jm_page = jm_pages-limit;
      //     }
          let jm_page = (pageNumber-1)*10;
          // console.log("last_page = ",last_page );
          // console.log("jm_pages = ",jm_pages );
          // console.log("jm_page = ",jm_page );
          // console.log("limit = ", limit );
          // console.log("pageNumber = ",pageNumber );
          this.setState({loading: false, display: false,last_page: pageNumber,activePage: pageNumber,jm_pages:jm_page});
          let userdata = JSON.parse(localStorage.getItem("userdata"));
          let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
          let session = "";
          if(userdata){
            session = 
            // "?token="+userdata.token+
            "?id_pengguna="+userdata.id_pengguna+
            "&id_unit="+sessiondata.i_idunit +
            "&id_role="+sessiondata.i_idrole;
          }
          var formData = new FormData();
          formData.append('data[keyword]', this.state.keyword);
          formData.append('data[id_unit]', this.state.lingkup_kordinasi);
          formData.append('data[mengisi]', "presentase");
          formData.append('data[kelengkapan_pengaturan]', this.state.kelengkapan_pengaturan);
          Axios.post(
              AppConfig.urlApiGetListPT+session+"&limit="+limit+'&page='+jm_page, formData)
            .then(res => {
            this.setState({
              data: res.data.result.data,
              totalRows: res.data.result.total_rows,
              loading: false,
              display: true,
            })
          }).catch(err => {
            this.setState({
              loading: false,
            })
            console.log(err);
          })
    }
    SearchInstitusi = (e) => {
      let id_institusi = localStorage.getItem("id_sp_temp");
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let id_sp = sessiondata.i_idunit;
      if(id_institusi !== ""){
          id_sp = id_institusi;
      }if(id_institusi === null){
          id_sp = sessiondata.i_idunit;
      }
      let session = "";
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      if(userdata){
          session = 
          // "?token="+userdata.token+
          "?id_pengguna="+userdata.id_pengguna+
          "&id_unit="+ id_sp +
          "&id_role="+sessiondata.i_idrole;
      }
      e.preventDefault();
      var formData = new FormData();
      formData.append('data[keyword]', this.state.keyword);
      formData.append('data[mengisi]', "presentase");    
      formData.append('data[id_unit]', this.state.lingkup_kordinasi);
      formData.append('data[kelengkapan_pengaturan]', this.state.kelengkapan_pengaturan);
      this.setState({ loading: true });
      Axios.post(
        AppConfig.urlApiGetListPT+session+"&limit="+this.state.limit
        , formData
      ).then(res => {
        this.setState({
          data: res.data.result.data,
          totalRows: res.data.result.total_rows,
          loading: false,
          display: true,
          full: res,
        });
      }) 
      .catch(err => {
        alert("not found")
        console.log(err)
        this.setState({
          loading: false,
          display: false,
        });
      })
    }
    ResetFilter = (e) =>{
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        e.preventDefault();
        this.setState({
          keyword : "",
          kelengkapan_fltr: "",
          lingkup_kordinasi: sessiondata.i_idunit,
        })
        this.componentDidMount();
      }
    render(){
        let userdata = JSON.parse(localStorage.getItem('sessiondata'));
        const { loading, data, totalRows, keyword, ref_lingkup, lingkup_kordinasi } = this.state;
        var i = 0;
        let result_ref = [];
        for (var key in ref_lingkup){
          result_ref[i] = {
            "name": key,
            "result": ref_lingkup[key],
          }
          i++;
        }
        let display_return = "";
        if(this.state.display === true){
            display_return = <>
            <Grid container spacing={3}>
                <Grid item xs={12} style={{textAlign:'left'}}>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">Kata Kunci</label>
                      <div className="col-lg-9 col-xl-6">
                        <div>
                          <input
                            type="text"
                            value={keyword}
                            onChange={(e) => this.onInputChangeName(e, 'keyword')}
                            className={`form-control form-control-lg form-control-solid `}
                            placeholder="Masukan keyword : Nama Perguruan Tinggi"
                            name="nama"
                          />
                        </div>
                      </div>
                    </div>
                    {
                      userdata.i_idrole === "1" || userdata.i_idrole === "10" || userdata.i_idrole === 1 || userdata.i_idrole === 10 ?
                      <>
                      <div className="form-group row">
                        <label className="col-xl-3 col-lg-3">Lingkup Koordinasi</label>
                        <div className="col-lg-9 col-xl-6">
                          <select
                            value={lingkup_kordinasi}
                            onChange={(e) => this.onInputChangeName(e, 'lingkup_kordinasi')}
                            className="form-control form-control-lg form-control-solid"
                            name="language"
                          >
                            <option value={userdata.i_idunit}>Semua Unit</option>
                            {
                              result_ref.map((list, i) =>
                              <option value={list.name}>{list.result}</option>
                              )
                            }
                          </select>
                        </div>
                      </div>
                      </>
                      :
                      ""
                    }
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3">Kelengkapan Pengisian</label>
                      <div className="col-lg-9 col-xl-6">
                        <select
                          value={lingkup_kordinasi}
                          onChange={(e) => this.onInputChangeName(e, 'kelengkapan_pengaturan')}
                          className="form-control form-control-lg form-control-solid"
                          name="language"
                        >
                          <option value={0}>Semua</option>
                          <option value={1}>1/6</option>
                          <option value={2}>2/6</option>
                          <option value={3}>3/6</option>
                          <option value={4}>4/6</option>
                          <option value={5}>5/6</option>
                          <option value={6}>6/6</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label"></label>
                      <div className="col-lg-9 col-xl-6" style={{textAlign:'center'}}>
                        <Button variant="primary" onClick={this.SearchInstitusi}>
                            Filter Data &nbsp;&nbsp;&nbsp;&nbsp;
                            <span className="fa fa-search"></span>
                        </Button>
                        <Button variant="default" onClick={this.ResetFilter} style={{marginLeft:'10px'}}>
                            Reset &nbsp;&nbsp;&nbsp;&nbsp;
                            <span className="fa fa-times"></span>
                        </Button>
                      </div>
                    </div>
                    <DataTable
                        title=""
                        // style={{marginTop:'-10%'}}
                        progressPending={loading}
                        columns={columns}
                        data={data}
                        />
                        
                </Grid>
                <Grid item xs={4}><span style={{fontStyle:'italic', fontSize:'12px', color:'#b5b5b5'}}>Total data : &nbsp;{this.state.totalRows}</span></Grid>
                <Grid item xs={8} style={{textAlign:'right'}}>
                <Pagination
                hideDisabled
                // add itemClass and LinkClass
                itemclassName="page-item"
                linkclassName="page-link"
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.limit}
                totalItemsCount={totalRows}
                pageRangeDisplayed={10}
                onChange={this.handlePageChange.bind(this)}
                />
                </Grid>
            </Grid>
            </>
        }else{
            display_return = <><LinearProgress color="secondary" variant="query" /></>
        }
        return(
            <>
            <div className="col-lg-12 col-xxl-12" style={{textAlign:''}}>
                <Notice svg="/media/svg/icons/Home/Building.svg" style={{marginBottom:'-12px',boxShadow:'none'}}>
                    <strong style={{fontSize:'18px'}}>PERGURUAN TINGGI</strong><p>Data Perguruan Tinggi Yang Telah Mengisi Aspek Pengaturan Kebijakan SPMI</p>
                </Notice>
                <hr/>
                {display_return}
            </div> 
            </>
        )
    }
}
export default TableListPTMengisi;